import { findByChainId } from 'chain-list'

import { fetcher } from '../utils'

import { useLocalStorage } from './useLocalStorage'

export const useWalletScreening = function () {
  const [bannedWallets, setBannedWallets] = useLocalStorage('bannedWallets', {})
  const isWalletApproved = function (address, chainId) {
    if (bannedWallets[chainId] && bannedWallets[chainId].includes(address)) {
      return Promise.resolve(false)
    }
    const chainShortName = findByChainId(chainId).shortName
    return fetcher(`/api/${chainShortName}/wallet-screening/${address}`).then(
      function (res) {
        if (!res.approved) {
          setBannedWallets({
            ...bannedWallets,
            [chainId]: bannedWallets[chainId]
              ? [...bannedWallets[chainId], address]
              : [address]
          })
        }
        return res.approved
      }
    )
  }

  return { bannedWallets, isWalletApproved }
}
